import React, {useEffect, useState} from "react";
import ModalForm from "../../../../../../components/modalComponents/ModalForm";
import {usePropsInputs} from "../../../../../../hooks/useProps/usePropsInput";
import {Div} from "../../../../../registroMaternidad/modales/components/Components";
import InputText from "../../../../../../components/modalComponents/InputText";
import InputCheckBox from "../../../../../../components/modalComponents/InputCheckBox";
import {
    cuadroRequerimientosEditarAsignacionAPI,
    cuadroRequerimientosGenerateEspecialidadAPI,
    cuadroRequerimientosGetAsistentesDisponiblesParaAsignacionAPI, cuadroRequerimientosGetDataToEditAsignacionAPI,
    cuadroRequerimientosGetProfesoresDisponiblesParaAsignacionAPI, cuadroRequerimientosRegistrarAsignacionAPI,
    cuadroRequerimientosGetAllSubEspecialidadesDeArteAPI,
    cuadroRequerimientosGetAllVacantesProfesorAPI, cuadroRequerimientosGetAllVacantesAsistenteAPI,
    cuadroRequerimientosGetDataForAsignacionModalAPI, cuadroRequerimientosGetTotalNroHorasForBloquesAPI,
    cuadroRequerimientosRegistrarAsignacionProfesorVacanteVolanteAPI,
} from "../../../../../../consumers/backendApisUrls";
import useDidMountEffect from "../../../../../../hooks/useDidMountEffect/useDidMountEffect";
import {initialAllOptionPromises, isNullOrUndefinded} from "../../../../../../helper/utils";
import {useManageGetRequest} from "../../../../../../hooks/useManageGetRequest/useManageGetRequest";
import InputSelect from "../../../../../../components/modalComponents/InputSelect";
import InputSearchAsyncPost from "../../../../../../components/modalComponents/InputSearchAsyncPost";
import {usePropsSelect} from "../../../../../../hooks/useProps/usePropsSelect";
import {useGetOptionsSelect} from "../../../../../../hooks/useGetOptionsSelect/useGetOptionsSelect";
import {useManagePostRequest} from "../../../../../../hooks/useManagePostRequest/useManagePostRequest";
import {useSubmitForm} from "../../../../../../hooks/useSubmitForm/useSubmitForm";
import {toast} from "react-toastify";

const KEYS = {
    IdCuadroSede: "IdCuadroSede",
    IdsCuadroBloques: "IdsCuadroBloques",
    IdEmpleadoProfesor: "IdEmpleadoProfesor",
    EmpleadoProfesor: "EmpleadoProfesor",
    EsVacanteProfesor: "EsVacanteProfesor",
    IdSubEspecialidadProfesor: "IdSubEspecialidadProfesor",
    IdEmpleadoAsistente: "IdEmpleadoAsistente",
    EmpleadoAsistente:"EmpleadoAsistente",
    EsVacanteAsistente: "EsVacanteAsistente",

    Especialidad: "Especialidad",
    NroBloques: "NroBloques",
    Plaza: "Plaza",
    PlazaConsolidada: "PlazaConsolidada",


    EspecialidadConsolidada: "EspecialidadConsolidada",
    NroBloquesConsolidada: "NroBloquesConsolidada",

    ProfesorCompleto: "ProfesorCompleto",
    IdVacanteProfesor: "IdVacanteProfesor",
    IdVacanteAsistente: "IdVacanteAsistente",
    IdAsignacionAsistente: "IdAsignacionAsistente",

};

const KEYS_DROPDOWN = [
    "IdSubEspecialidadProfesor",
    "IdVacanteProfesor",
    "IdVacanteAsistente"
];

const IdVacanteNuevo = 9998;
const IdVacanteVolante = 9997;

export default function CuadroRequerimientosAsignar({toggleModal, refreshPage, idCuadroSede, idsCuadroBloque, idAsignacionProp, isFromEditar}) {
    const SECTION_NAME = "CuadroRequerimientosAsignar"
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formValues, setFormValues] = useState({});
    const [formValuesAlreadySaved, setFormValuesAlreadySaved] = useState({});
    const [commonProps] = usePropsInputs(formValues, setFormValues, SECTION_NAME);
    const [isEditable, setIsEditable] = useState(true);
    const [allDropdowns, setAllDropdowns] = useState([]);
    const [hasAsistenteAlreadySaved, setHasAsistenteAlreadySaved] = useState(false);
    const [dataForModal, setDataForModal] = useState({});
    const [getOption] = useGetOptionsSelect();
    const [executeManagePost] = useManagePostRequest();
    const [manageGetRequest] = useManageGetRequest();
    const [submitForm] = useSubmitForm();
    const isInitialLoad = React.useRef(true);
    const isMounted = React.useRef(true);
    const [idAsignacion, setIdAsignacion] = useState();

    // El modal se cierra al guardar con éxito; evita el setState sobre un componente desmontado.
    useEffect(() => () => { isMounted.current = false; }, []);

    const safeSetIsSubmitting = (value) => {
        if (isMounted.current) setIsSubmitting(value);
    };

    const [addVolanteOption] = useState(idsCuadroBloque.length === 0);

    useEffect(()=>{
        setIdAsignacion(idAsignacionProp)
    },[idAsignacionProp])



    const [selectProps] = usePropsSelect(
        allDropdowns,
        formValues,
        setFormValues,
        SECTION_NAME
    );

    const getIdAsignacion = () => {

        if (!isFromEditar){
            if (formValues[KEYS.EsVacanteProfesor] === true)
            {
                if (formValues[KEYS.IdVacanteProfesor] === IdVacanteNuevo)
                    return undefined
                return formValues[KEYS.IdVacanteProfesor]
            }

            return formValues[KEYS.ProfesorCompleto]?.IdAsignacion;
        }

        return idAsignacion;

    }


    const RegistrarAsignacionProfesorVacanteVolante = async () => {
        const payload ={
            "IdCuadroSede": idCuadroSede
        }
        const api = cuadroRequerimientosRegistrarAsignacionProfesorVacanteVolanteAPI();
        await executeManagePost(api, payload, successRegistrarAsignacionProfesorVacanteVolanteCallback);
    }

    const successRegistrarAsignacionProfesorVacanteVolanteCallback = ({data}) => {
        toggleModal()
    }


    const handleSubmit = async (e) => {
        if (e)
            e.preventDefault();

        if (isSubmitting) return;

        setIsSubmitting(true);

        try {
            if (formValues[KEYS.IdVacanteProfesor] === IdVacanteVolante && idsCuadroBloque.length === 0){
                await RegistrarAsignacionProfesorVacanteVolante()
                return;
            }

            // El backend también rechaza la asignación sin bloques, pero su mensaje viaja
            // en el ModelState de "IdsCuadroBloques", y ese campo no tiene input en el
            // modal (los bloques se eligen en la grilla), así que no hay dónde pintarlo.
            if (idsCuadroBloque.length === 0) {
                toast.error("Debe seleccionar al menos un bloque para realizar la asignación");
                return;
            }

            if (isFromEditar) {
                await editarAsignacionProfesor(idAsignacion);
                return;
            }

            if (isNullOrUndefinded(idAsignacion))
            {
                await crearAsignacionProfesorConAsistenteOpcional();
            }
            else
            {
                await editarAsignacionProfesor(idAsignacion);
            }
        } finally {
            safeSetIsSubmitting(false);
        }
    }

    const editarAsignacionProfesor = async (idAsignacion) => {
        const payload ={
            "IdAsignacion": idAsignacion,
            "IdsCuadroBloquesToAdd": idsCuadroBloque,
            "IdSubEspecialidad": formValues[KEYS.IdSubEspecialidadProfesor]
        }
        const api = cuadroRequerimientosEditarAsignacionAPI();

        try {
            await submitForm(Object.values(KEYS), api, payload, SECTION_NAME, successCrearEditarAsignacionCallback, true);
        } catch (error) {
            console.error(error);
        }
    }

    const crearAsignacionProfesorConAsistenteOpcional = async () => {
        const payload ={
            "IdCuadroSede": idCuadroSede,
            "IdsCuadroBloques": idsCuadroBloque,
            "IdSubEspecialidadProfesor": formValues[KEYS.IdSubEspecialidadProfesor],

            "EsVacanteProfesor": formValues[KEYS.EsVacanteProfesor]??false,
            "IdEmpleadoProfesor": (formValues[KEYS.EsVacanteProfesor] ? null : formValues[KEYS.IdEmpleadoProfesor]),
            "IdVacanteProfesor": formValues[KEYS.EsVacanteProfesor] ? formValues[KEYS.IdVacanteProfesor] : null,

            "EsVacanteAsistente": formValues[KEYS.EsVacanteAsistente]??false,
            "IdEmpleadoAsistente": (formValues[KEYS.EsVacanteAsistente] ? null : formValues[KEYS.IdEmpleadoAsistente]),
            "IdVacanteAsistente": formValues[KEYS.EsVacanteAsistente] ? formValues[KEYS.IdVacanteAsistente]: null,

        }
        const api = cuadroRequerimientosRegistrarAsignacionAPI();

        try {
            await submitForm(Object.values(KEYS), api, payload, SECTION_NAME, successCrearEditarAsignacionCallback, true);
        } catch (error) {
            console.error(error);
        }
    }

    const successCrearEditarAsignacionCallback = async ({data}) => {
        await refreshPage();
        toggleModal();
    }

    const getDropdowns = async () => {

        const dropdownsPromises = () => [
            getOption(cuadroRequerimientosGetAllSubEspecialidadesDeArteAPI()),
            getOption(cuadroRequerimientosGetAllVacantesProfesorAPI(idCuadroSede, addVolanteOption)),
            getOption(cuadroRequerimientosGetAllVacantesAsistenteAPI(idCuadroSede)),

        ]
        await initialAllOptionPromises(dropdownsPromises, KEYS_DROPDOWN, handleDropdowns);
    }

    const handleDropdowns = (data) => {
        setAllDropdowns([...data]);
    }

    const handleProfesorChange = (e) => {
        const selected = e.target.value;

        setFormValues(prev => ({
            ...prev,
            IdEmpleadoProfesor: selected.value,
            EmpleadoProfesor: selected.label,
            ProfesorCompleto: selected.data
        }));
    };

    const handleAsistenteChange = (e) => {
        const selected = e.target.value;

        setFormValues(prev => ({
            ...prev,
            IdEmpleadoAsistente: selected.value,
            EmpleadoAsistente: selected.label,
            AsistenteCompleto: selected.data
        }));
    };


    const getInitData = async () => {
        getDropdowns();
        if (!isFromEditar){
            generarEspecialidad();
            generarEspecialidadConsolidada();
            generarNroBloques()
            generarNroBloquesConsolidada()
            getDataForModal();
        }

    }

    const getDataForModal = async () => {
        const payload ={
            "IdsCuadroBloques": idsCuadroBloque,
            "IdAsignacion": idAsignacion
        }
        const api = cuadroRequerimientosGetDataForAsignacionModalAPI();
        await executeManagePost(api, payload, successGetataForModalCallback);
    }

    const successGetataForModalCallback = ({data}) => {
        setDataForModal({...data})
    }

    const generarEspecialidad = async () => {
        const payload ={
            "IdsCuadroBloques": idsCuadroBloque,
            "IdCuadroSede": idCuadroSede,
            "EsVacante": formValues[KEYS.EsVacanteProfesor],
            "IdSubEspecialidad": formValues[KEYS.IdSubEspecialidadProfesor],
            "IdAsignacion": isFromEditar ? idAsignacion: null,
            "EsVacanteVolante": formValues[KEYS.IdVacanteProfesor] === IdVacanteVolante

        }
        const api = cuadroRequerimientosGenerateEspecialidadAPI();
        await executeManagePost(api, payload, successGenerarEspecialidadCallback);
    }

    const successGenerarEspecialidadCallback = ({data}) => {
        setFormValues(lastData => ({...lastData, [KEYS.Especialidad]: data.Especialidad}));
    }

    const generarEspecialidadConsolidada = async () => {
        const payload ={
            "IdsCuadroBloques": idsCuadroBloque,
            "IdCuadroSede": idCuadroSede,
            "EsVacante": formValues[KEYS.EsVacanteProfesor],
            "IdAsignacion": idAsignacion,
            "IdSubEspecialidad": formValues[KEYS.IdSubEspecialidadProfesor],
            "EsVacanteVolante": formValues[KEYS.IdVacanteProfesor] === IdVacanteVolante
        }


        const api = cuadroRequerimientosGenerateEspecialidadAPI();
        await executeManagePost(api, payload, successGenerarEspecialidadConsolidadaCallback);
    }

    const successGenerarEspecialidadConsolidadaCallback = ({data}) => {
        setFormValues(lastData => ({...lastData, [KEYS.EspecialidadConsolidada]: data.Especialidad}));
    }

    /////
    const generarNroBloques = async () => {
        const payload ={
            "IdsCuadroBloques": idsCuadroBloque,
            "IdEmpleado" : formValues[KEYS.IdEmpleadoProfesor],
            "EsVacante" : formValues[KEYS.EsVacanteProfesor] ?? false
        }
        const api = cuadroRequerimientosGetTotalNroHorasForBloquesAPI();
        await executeManagePost(api, payload, successGenerarNroBloquesCallback);
    }

    const successGenerarNroBloquesCallback = ({data}) => {
        setFormValues(lastData => ({...lastData, [KEYS.NroBloques]: data.NroBloques, [KEYS.Plaza] : data.Plaza}));
    }

    const generarNroBloquesConsolidada = async () => {
        const payload ={
            "IdsCuadroBloques": idsCuadroBloque,
            "IdAsignacion": idAsignacion,
            "IdEmpleado" : formValues[KEYS.IdEmpleadoProfesor],
            "EsVacante" : formValues[KEYS.EsVacanteProfesor] ?? false
        }

        const api = cuadroRequerimientosGetTotalNroHorasForBloquesAPI();
        await executeManagePost(api, payload, successGenerarNroBloquesConsolidadaCallback);
    }

    const successGenerarNroBloquesConsolidadaCallback = ({data}) => {
        setFormValues(lastData => ({...lastData, [KEYS.NroBloquesConsolidada]: data.NroBloques,  [KEYS.PlazaConsolidada]: data.Plaza}));
    }

    const getAsignacionById = async (idAsignacion) => {
        if (isNullOrUndefinded(idAsignacion) || idAsignacion === 0){
            setFormValuesAlreadySaved({});
        }else{
            await manageGetRequest(cuadroRequerimientosGetDataToEditAsignacionAPI(idAsignacion), callbackSuccessGetAsignacionByIdToEdit, false);
        }
    }

    const callbackSuccessGetAsignacionByIdToEdit = (response) => {
        setFormValuesAlreadySaved(response.data);
        setFormValues(lastData => ({...(response.data),
            Especialidad: response?.data?.EspecialidadProfesor,
            AsignacionAsistenteEspecialidad: response?.data?.AsignacionAsistenteEspecialidad,
            EspecialidadConsolidada:  response?.data?.EspecialidadProfesor,
            NroBloques : response?.data?.NroTotalBloquesForAsignacion,
            NroBloquesConsolidada : response?.data?.NroTotalBloquesForAsignacion,
            Plaza : response?.data?.Plaza,
            PlazaConsolidada: response?.data?.Plaza,
            IdVacanteProfesor: response?.data?.EsVacanteProfesor ? response?.data?.IdAsignacionProfesor : undefined, ...lastData
        }))



        setTimeout(() => { isInitialLoad.current = false; }, 100);
    }





    useDidMountEffect(() => {
        if (isInitialLoad.current || formValues[KEYS.EsVacanteProfesor] === formValuesAlreadySaved[KEYS.EsVacanteProfesor]) {
            return;
        }
        const camposToReset = {
            ProfesorCompleto: null,
            IdEmpleadoProfesor: null,
            EmpleadoProfesor: null,
            IdVacanteProfesor: null
        };
        setFormValues(lastData => ({...lastData,  ...camposToReset}))

    }, [formValues[KEYS.EsVacanteProfesor]]);

    useDidMountEffect(() => {
        if (isInitialLoad.current || formValues[KEYS.EsVacanteAsistente] === formValuesAlreadySaved[KEYS.EsVacanteAsistente]) {
            return;
        }
        const camposToReset = {
            IdVacanteAsistente: null,
            AsistenteCompleto: null,
            EmpleadoAsistente: null,
            IdEmpleadoAsistente: null,
        };
        setFormValues(lastData => ({...lastData,  ...camposToReset}))

    }, [formValues[KEYS.EsVacanteAsistente]]);


    useDidMountEffect(() => {
        setIdAsignacion(getIdAsignacion());
    }, [formValues[KEYS.EsVacanteProfesor], formValues[KEYS.IdVacanteProfesor], [formValues[KEYS.ProfesorCompleto]?.IdAsignacion]]);

    useDidMountEffect(() => {
        isInitialLoad.current = true;
        if (!isFromEditar){

            generarNroBloques();
            generarNroBloquesConsolidada()
            generarEspecialidad();
            generarEspecialidadConsolidada();
        }



        getDataForModal();
        getAsignacionById(idAsignacion)
    }, [idAsignacion])

    useDidMountEffect(()=>{
        generarEspecialidad();
        generarEspecialidadConsolidada();
    },[formValues[KEYS.IdSubEspecialidadProfesor], formValues[KEYS.EsVacanteProfesor]])

    useDidMountEffect(()=>{
        if (!isFromEditar){
            generarNroBloques();
            generarNroBloquesConsolidada()
        }
    },[formValues[KEYS.EsVacanteProfesor]])

    useEffect(() => {
        if (isNullOrUndefinded(formValuesAlreadySaved[KEYS.IdAsignacionAsistente]) || formValuesAlreadySaved[KEYS.IdAsignacionAsistente] === 0 ){
            setHasAsistenteAlreadySaved(false)
        }else {
            setHasAsistenteAlreadySaved(true)
        }
    }, [formValuesAlreadySaved]);

    useEffect(() => {
            getInitData()
        }
    , [])

    return (
    <>
        <ModalForm
            titulo="Asignar"
            width="800px"
            label={isSubmitting ? "Cargando" : "Guardar"}
            showModal={toggleModal}
            isSubmitting={isSubmitting}
            saveButtonDisabled={isSubmitting}
            onSubmit={handleSubmit}>

            <div className="displayFlexWrap">
                <>
                    <Div col={12} >
                        <hr className={"mt-1 mb-1"}/>
                        <p className={"mb-0"}><strong>Profesor</strong></p>
                    </Div>
                    <Div col={6} >
                        <InputCheckBox
                            label="Es Vacante"
                            {...commonProps(KEYS.EsVacanteProfesor)}
                            sectionName={SECTION_NAME}
                            isDisabled={isFromEditar}
                            isRequired={true}
                        />
                    </Div>
                    <Div col={12}>
                        {formValues[KEYS.EsVacanteProfesor] === true &&
                            <InputSelect
                                label="Vacante"
                                {...selectProps(KEYS.IdVacanteProfesor)}
                                sectionName={SECTION_NAME}
                                isDisabled={isFromEditar}
                                isRequired={true}
                                placeholder={"Seleccionar Vacante"}
                                direction="column"
                            />
                        }

                        {formValues[KEYS.EsVacanteProfesor] !== true &&
                            <InputSearchAsyncPost
                                label='Profesor'
                                api={cuadroRequerimientosGetProfesoresDisponiblesParaAsignacionAPI}

                                buildPayload={(inputValue) => ({
                                    "IdCuadroSede": idCuadroSede,
                                    "Criteria": inputValue
                                })}

                                onChange={handleProfesorChange}
                                name={KEYS.IdEmpleadoProfesor}
                                value={formValues[KEYS.IdEmpleadoProfesor]}
                                valueText={formValues[KEYS.EmpleadoProfesor]}
                                direction="column"
                                isDisabled={isFromEditar}
                                isRequired={true}
                                sectionName={SECTION_NAME}
                            />
                        }

                    </Div>
                    <Div col={4} >
                    <InputText
                        label={"Nro. Bloques"}
                        {...commonProps(KEYS.NroBloques)}
                        sectionName={SECTION_NAME}
                        direction="column"
                        isRequired={false}
                        isDisabled={true}
                        placeholder={""}
                    />
                    </Div>

                    <Div col={4} >
                        <InputText
                            label={"Plaza"}
                            {...commonProps(KEYS.Plaza)}
                            sectionName={SECTION_NAME}
                            direction="column"
                            isRequired={false}
                            isDisabled={true}
                            placeholder={""}
                        />
                    </Div>

                    <Div col={dataForModal?.MostrarSubEspecialidad === true ? 6 : 12}>
                        <InputText
                            label={"Especialidad"}
                            {...commonProps(KEYS.Especialidad)}
                            sectionName={SECTION_NAME}
                            direction="column"
                            isRequired={false}
                            isDisabled={true}
                            placeholder={""}

                        />
                    </Div>

                    {dataForModal?.MostrarSubEspecialidad === true &&
                        <Div col={6}>
                            <InputSelect
                                label="Sub Especialidad"
                                {...selectProps(KEYS.IdSubEspecialidadProfesor)}
                                sectionName={SECTION_NAME}
                                isDisabled={!isEditable}
                                isRequired={true}
                                placeholder={"Seleccionar Sub Especialidad"}
                                direction="column"
                            />

                        </Div>
                    }



                    {dataForModal?.TieneAsistenteEducacion === true &&
                    <>
                        <Div col={12} >
                            <hr className={"mt-1 mb-1"}/>
                            <p className={"mb-0"}><strong>Asistente de educación</strong></p>
                        </Div>

                        {hasAsistenteAlreadySaved !== true  &&
                            <Div col={6} >
                                <InputCheckBox
                                    label="Es Vacante"
                                    {...commonProps(KEYS.EsVacanteAsistente)}

                                    sectionName={SECTION_NAME}
                                    isDisabled={hasAsistenteAlreadySaved}
                                    isRequired={true}
                                />
                            </Div>
                        }

                        <Div col={12}>

                            {hasAsistenteAlreadySaved === true &&
                                <InputText
                                    label={"Asistente de educación"}
                                    value={ formValuesAlreadySaved[KEYS.EsVacanteAsistente] === true ?  formValuesAlreadySaved["AsignacionAsistenteEspecialidad"] : formValuesAlreadySaved[KEYS.EmpleadoAsistente]}
                                    name={"empleadoAsistente"}
                                    sectionName={SECTION_NAME}
                                    direction="column"
                                    isRequired={false}
                                    isDisabled={true}
                                    placeholder={""}

                                />
                            }


                            {formValues[KEYS.EsVacanteAsistente] === true && hasAsistenteAlreadySaved !== true &&
                                <InputSelect
                                    label="Vacante"
                                    {...selectProps(KEYS.IdVacanteAsistente)}
                                    sectionName={SECTION_NAME}
                                    isDisabled={hasAsistenteAlreadySaved}
                                    isRequired={true}
                                    placeholder={"Seleccionar Vacante"}
                                    direction="column"
                                />
                            }

                            {formValues[KEYS.EsVacanteAsistente] !== true &&  hasAsistenteAlreadySaved !== true &&
                                <InputSearchAsyncPost
                                    label='Asistente de educación'
                                    api={cuadroRequerimientosGetAsistentesDisponiblesParaAsignacionAPI}

                                    buildPayload={(inputValue) => ({
                                        "IdCuadroSede": idCuadroSede,
                                        "Criteria": inputValue
                                    })}

                                    onChange={handleAsistenteChange}
                                    name={KEYS.IdEmpleadoAsistente}
                                    value={formValues[KEYS.IdEmpleadoAsistente]}
                                    valueText={formValues[KEYS.EmpleadoAsistente]}

                                    sectionName={SECTION_NAME}
                                    direction="column"
                                    isDisabled={hasAsistenteAlreadySaved}
                                    isRequired={true}
                                />
                            }
                        </Div>
                    </>
                    }


                    <Div col={12} >
                        <hr className={"mt-1 mb-1"}/>
                        <p className={"mb-0"}><strong>Consolidado</strong></p>
                    </Div>

                    <Div col={12}>
                        <InputText
                            label={"Especialidad"}
                            {...commonProps(KEYS.EspecialidadConsolidada)}
                            sectionName={SECTION_NAME}
                            direction="column"
                            isRequired={false}
                            isDisabled={true}
                            placeholder={""}
                        />
                    </Div>

                    <Div col={4}>
                        <InputText
                            label={"Nro. Bloques"}
                            name={"NroBloquesConsolidado"}
                            {...commonProps(KEYS.NroBloquesConsolidada)}
                            sectionName={SECTION_NAME}
                            direction="column"
                            isRequired={false}
                            isDisabled={true}
                            placeholder={""}
                        />
                    </Div>

                    <Div col={4}>
                        <InputText
                            label={"Plaza"}
                            sectionName={SECTION_NAME}
                            {...commonProps(KEYS.PlazaConsolidada)}
                            direction="column"
                            isRequired={false}
                            isDisabled={true}
                            placeholder={""}
                        />
                    </Div>
                </>
            </div>
        </ModalForm>

    </>

    );

}

